import { QuickGrabTask } from '@scale/shared/quickGrab/types';
import { Table } from '@scale/scaleui';
import { TableDataUtils } from '@scale/compass-ui/components/TableDataUtils';
import { columnsFromRecord } from '@scale/compass-shared/utils';
import { useMemo } from 'react';

interface QuickGrabTasksProps {
  quickGrabTasks: QuickGrabTask[];
}

function QuickGrabTasks({ quickGrabTasks }: QuickGrabTasksProps) {
  const tableData = useMemo(() => {
    return quickGrabTasks.map(task => ({
      taskId: task.taskId,
      prompt: task.prompt,
      createdAt: task.createdAt === '-' ? '-' : new Date(task.createdAt).toLocaleString(),
      lastAttemptedAt:
        task.lastAttemptedAt === '-' ? '-' : new Date(task.lastAttemptedAt).toLocaleString(),
    }));
  }, [quickGrabTasks]);

  const columns = useMemo(() => {
    const allColumns = TableDataUtils.formatTableColumns(columnsFromRecord(tableData));
    return allColumns.filter(column => {
      const columnId = column.id as keyof (typeof tableData)[0];
      return !tableData.every(row => {
        const value = row[columnId];
        return value === undefined || value === '' || value === '-';
      });
    });
  }, [tableData]);

  return (
    <Table
      data={tableData}
      columns={columns}
      defaultPageSize={tableData?.length}
      manualPagination={true}
    />
  );
}

export default QuickGrabTasks;
